// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Particle_Screen_Css = require("./Particle_Screen_Css.bs.js");
var Particle_Animation_Ds = require("./Particle_Animation_Ds.bs.js");

function getTimingFunction(timingFunction) {
  if (typeof timingFunction !== "number") {
    return CssJs.cubicBezier(timingFunction._0, timingFunction._1, timingFunction._2, timingFunction._3);
  }
  switch (timingFunction) {
    case /* EaseOut */0 :
        return CssJs.easeOut;
    case /* EaseInOut */1 :
        return CssJs.easeInOut;
    case /* CubicBezier */2 :
        return CssJs.cubicBezier(0.63, 0.24, 0.93, 0.2);
    case /* Linear */3 :
        return CssJs.linear;
    
  }
}

function viewFieldToRules(viewField) {
  var keyframes = viewField.keyframes;
  var keyframes$1;
  if (typeof keyframes === "number") {
    switch (keyframes) {
      case /* OpacityIn */0 :
          keyframes$1 = [
            [
              0,
              [CssJs.opacity(0)]
            ],
            [
              100,
              [CssJs.opacity(1)]
            ]
          ];
          break;
      case /* OpacityOut */1 :
          keyframes$1 = [
            [
              0,
              [CssJs.opacity(1)]
            ],
            [
              100,
              [CssJs.opacity(0)]
            ]
          ];
          break;
      case /* RevealText */2 :
          keyframes$1 = [
            [
              0,
              [CssJs.transforms([
                      CssJs.translate(CssJs.pct(-100), CssJs.pct(0)),
                      CssJs.rotate(CssJs.deg(0))
                    ])]
            ],
            [
              100,
              [CssJs.transforms([
                      CssJs.translate(CssJs.pct(0), CssJs.pct(0)),
                      CssJs.rotate(CssJs.deg(0))
                    ])]
            ]
          ];
          break;
      case /* TranslationLeft */3 :
          keyframes$1 = [
            [
              0,
              [CssJs.left(CssJs.vw(15))]
            ],
            [
              100,
              [CssJs.left(CssJs.pct(0))]
            ]
          ];
          break;
      case /* TranslationRight */4 :
          keyframes$1 = [
            [
              0,
              [CssJs.transform(CssJs.translate3d(CssJs.vw(-40), CssJs.px(0), CssJs.px(0)))]
            ],
            [
              100,
              [CssJs.transform(CssJs.translate3d(CssJs.px(0), CssJs.px(0), CssJs.px(0)))]
            ]
          ];
          break;
      case /* Nothing */5 :
          keyframes$1 = [];
          break;
      
    }
  } else if (keyframes.TAG === /* Open */0) {
    keyframes$1 = [
      [
        0,
        [
          CssJs.opacity(0),
          CssJs.maxHeight(CssJs.px(0))
        ]
      ],
      [
        20,
        [
          CssJs.opacity(0),
          CssJs.maxHeight(CssJs.px(keyframes._0 | 0))
        ]
      ],
      [
        100,
        [CssJs.opacity(1)]
      ]
    ];
  } else {
    var match = keyframes._0;
    keyframes$1 = [
      [
        0,
        [CssJs.transform(CssJs.rotate(CssJs.deg(match.start)))]
      ],
      [
        100,
        [CssJs.transform(CssJs.rotate(CssJs.deg(match.end)))]
      ]
    ];
  }
  var iterationCount = viewField.iterationCount ? "infinite" : ({
        NAME: "count",
        VAL: 1
      });
  var fillMode = viewField.fillMode ? "none" : "forwards";
  var direction = viewField.direction ? "alternate" : "normal";
  var timingFunction = getTimingFunction(viewField.timingFunction);
  return [CssJs.animation(viewField.duration, viewField.delay, direction, timingFunction, fillMode, undefined, iterationCount, CssJs.keyframes(keyframes$1))];
}

function toCss(animation) {
  var view = Particle_Animation_Ds.view(animation);
  return Particle_Screen_Css.toRules(undefined, undefined, viewFieldToRules, view);
}

exports.getTimingFunction = getTimingFunction;
exports.viewFieldToRules = viewFieldToRules;
exports.toCss = toCss;
/* CssJs Not a pure module */
